module.exports = __webpack_public_path__ + "static/media/roadbook-balade.296693d7.pdf";